import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const flagCategories = [
    { name: 'Indian National Flags', path: '/flags/indian' },
    { name: 'BJP Party Flags', path: '/flags/bjp' },
    { name: 'Congress Party Flags', path: '/flags/congress' },
    { name: 'TRS Party Flags', path: '/flags/trs' },
    { name: 'TDP Party Flags', path: '/flags/tdp' },
    { name: 'Ganesh Festival Flags', path: '/flags/ganesh' },
    { name: 'Hanuman Devotional Flags', path: '/flags/hanuman' }
  ];

  const quickLinks = [
    { name: 'About Us', path: '/about' }
  ];

  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    // Newsletter signup logic here
    alert('Thank you for subscribing to our newsletter!');
  };

  return (
    <footer className="site-footer">
      {/* Main Footer Content */}
      <div className="footer-main">
        <div className="container">
          <div className="row">
            
            {/* Company Information */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="footer-section">
                <div className="footer-logo mb-4">
                  <div className="d-flex align-items-center">
                    <div className="animated-indian-flag me-3">
                      <svg width="40" height="27" viewBox="0 0 123 82" className="flag-svg">
                        <rect className="saffron-stripe" x="0" y="0" width="123" height="27" fill="#ff9933"/>
                        <rect className="white-stripe" x="0" y="27" width="123" height="28" fill="#ffffff"/>
                        <rect className="green-stripe" x="0" y="55" width="123" height="27" fill="#138808"/>
                        <circle className="chakra-circle" cx="61.5" cy="41" r="11" fill="none" stroke="#000080" strokeWidth="1"/>
                        <g className="chakra-spokes" stroke="#000080" strokeWidth="0.5">
                          <line x1="61.5" y1="30" x2="61.5" y2="52"/>
                          <line x1="50.5" y1="41" x2="72.5" y2="41"/>
                          <line x1="53.7" y1="33.2" x2="69.3" y2="48.8"/>
                          <line x1="69.3" y1="33.2" x2="53.7" y2="48.8"/>
                        </g>
                      </svg>
                    </div>
                    <div>
                      <h5 className="text-white mb-0">SR Indian Flags</h5>
                      <small className="text-muted">Premium Quality Flags</small>
                    </div>
                  </div>
                </div>
                
                <p className="footer-description text-light mb-4">
                  We are India's premier flag manufacturer, dedicated to creating high-quality flags for 
                  political parties, festivals, and national celebrations. Every flag is crafted with 
                  precision and patriotic pride.
                </p>

                {/* Contact Information */}
                <div className="contact-info">
                  <h6 className="text-white mb-3">
                    <i className="bi bi-telephone-fill me-2 text-success"></i>
                    Contact Information
                  </h6>
                  
                  <div className="contact-item mb-2">
                    <i className="bi bi-telephone text-success me-2"></i>
                    <a href="tel:9700388626" className="text-light text-decoration-none">
                      +91 9700388626
                    </a>
                  </div>
                  
                  <div className="contact-item mb-2">
                    <i className="bi bi-whatsapp text-success me-2"></i>
                    <a href="https://wa.me/919700388626" target="_blank" rel="noopener noreferrer" className="text-light text-decoration-none">
                      WhatsApp: +91 9700388626
                    </a>
                  </div>
                  
                  <div className="contact-item mb-2">
                    <i className="bi bi-envelope text-primary me-2"></i>
                    <a href="mailto:srflags@gmail.com" className="text-light text-decoration-none">
                      srflags@gmail.com
                    </a>
                  </div>
                  
                  <div className="contact-item mb-3">
                    <i className="bi bi-geo-alt text-warning me-2"></i>
                    <span className="text-light">
                      H.No 16-1-467, Kareemabad Road,<br/>
                      S R R Thota, Vada, Warangal,<br/>
                      Telangana 506002
                    </span>
                  </div>

                  {/* Business Hours */}
                  <div className="business-hours">
                    <h6 className="text-white mb-2">
                      <i className="bi bi-clock me-2 text-info"></i>
                      Business Hours
                    </h6>
                    <small className="text-muted d-block">Mon - Sat: 9:00 AM - 7:00 PM</small>
                    <small className="text-muted d-block">Sunday: 10:00 AM - 5:00 PM</small>
                  </div>
                </div>
              </div>
            </div>

            {/* Flag Categories */}
            <div className="col-lg-2 col-md-6 mb-4">
              <div className="footer-section">
                <h6 className="footer-title text-white mb-3">
                  <i className="bi bi-flag me-2 text-warning"></i>
                  Flag Categories
                </h6>
                <ul className="footer-links list-unstyled">
                  {flagCategories.map((category, index) => (
                    <li key={index} className="mb-2">
                      <Link to={category.path} className="text-muted text-decoration-none hover-link">
                        <i className="bi bi-chevron-right me-1"></i>
                        {category.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Quick Links */}
            <div className="col-lg-2 col-md-6 mb-4">
              <div className="footer-section">
                <h6 className="footer-title text-white mb-3">
                  <i className="bi bi-link-45deg me-2 text-info"></i>
                  Quick Links
                </h6>
                <ul className="footer-links list-unstyled">
                  {quickLinks.map((link, index) => (
                    <li key={index} className="mb-2">
                      <Link to={link.path} className="text-muted text-decoration-none hover-link">
                        <i className="bi bi-chevron-right me-1"></i>
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Newsletter & Social Media */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="footer-section">
                <h6 className="footer-title text-white mb-3">
                  <i className="bi bi-envelope-heart me-2 text-danger"></i>
                  Stay Connected
                </h6>
                
                <p className="text-muted mb-3">
                  Subscribe to our newsletter for latest flag designs, offers, and patriotic updates!
                </p>

                {/* Newsletter Signup */}
                <form onSubmit={handleNewsletterSubmit} className="newsletter-form mb-4">
                  <div className="input-group">
                    <input 
                      type="email" 
                      className="form-control" 
                      placeholder="Your email address"
                      required
                    />
                    <button className="btn btn-primary" type="submit">
                      <i className="bi bi-send"></i>
                    </button>
                  </div>
                </form>

                {/* Social Media Links */}
                <div className="social-media">
                  <h6 className="text-white mb-3">Contact Us:</h6>
                  <div className="social-links d-flex gap-3">
                    <a href="https://wa.me/919700388626" target="_blank" rel="noopener noreferrer" className="social-link whatsapp">
                      <i className="bi bi-whatsapp"></i>
                    </a>
                  </div>
                </div>

                {/* Quality Badges */}
                <div className="quality-badges mt-4">
                  <h6 className="text-white mb-3">Our Promise:</h6>
                  <div className="badges-container">
                    <div className="quality-badge">
                      <i className="bi bi-shield-check text-success me-2"></i>
                      <span className="text-muted">100% Quality</span>
                    </div>
                    <div className="quality-badge">
                      <i className="bi bi-truck text-warning me-2"></i>
                      <span className="text-muted">Fast Delivery</span>
                    </div>
                    <div className="quality-badge">
                      <i className="bi bi-headset text-info me-2"></i>
                      <span className="text-muted">24/7 Support</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <p className="copyright-text text-muted mb-0">
                &copy; {new Date().getFullYear()} SR Indian Flags. All rights reserved. 
                <span className="ms-2">Made with ❤️ in India</span>
              </p>
            </div>
            <div className="col-md-6">
              <div className="footer-bottom-links text-md-end mt-2 mt-md-0">
                <Link to="/about" className="text-muted text-decoration-none">About Us</Link>
              </div>
            </div>
          </div>
          
          {/* Patriotic Message */}
          <div className="row mt-3">
            <div className="col-12 text-center">
              <div className="patriotic-message">
                <p className="text-muted mb-0 small">
                  <i className="bi bi-heart-fill text-danger me-1"></i>
                  Proudly serving the nation with quality flags since inception
                  <i className="bi bi-heart-fill text-danger ms-1"></i>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Contact Actions - Mobile */}
      <div className="floating-contact-actions d-lg-none">
        <div className="floating-actions">
          <a href="tel:9700388626" className="floating-btn call-btn">
            <i className="bi bi-telephone-fill"></i>
          </a>
          <a href="https://wa.me/919700388626" target="_blank" rel="noopener noreferrer" className="floating-btn whatsapp-btn">
            <i className="bi bi-whatsapp"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;